<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

  export default {
    name: 'ContentOverlay',
    components: {
      FontAwesomeIcon
    },
    beforeCreate () {
      this.$store.commit('contentOverlays/increment')
    },
    beforeDestroy () {
      this.$store.commit('contentOverlays/decrement')
    },
    props: {
      title: {
        type: String
      },
      body: {
        type: String
      },
      noHeader: {
        type: Boolean
      },
      noTitle: {
        type: Boolean
      },
      noClose: {
        type: Boolean
      },
      bodyClass: {
        type: [String, Array, Object],
        default: () => ({})
      }
    }
  }
</script>

<template>
  <transition appear name="slide-and-fade" @after-enter="$emit('entered')" @after-leave="$emit('left')">
    <div class="content-overlay">
      <slot name="header">
        <div class="content-overlay__header d-flex align-items-center" v-if="!noHeader">
          <h2 class="content-overlay__header__title" v-if="!noTitle">
            {{ title }}
          </h2>
          <BButton class="content-overlay__header__close ml-auto" v-if="!noClose" @click="$emit('close')">
            <FontAwesomeIcon icon="times" size="2x" class="content-overlay__header__close__icon"></FontAwesomeIcon>
            <span class="sr-only">
              {{ $t('contentOverlay.close') }}
            </span>
          </BButton>
        </div>
      </slot>
      <div class="content-overlay__body" :class="bodyClass">
        <slot>
          {{ body }}
        </slot>
      </div>
    </div>
  </transition>
</template>

<style lang="scss" scoped>
  .content-overlay {
    background: rgba(#fff, 0.97);
    bottom: 0;
    color: #000;
    max-height: 100%;
    max-width: 820px;
    overflow-y: auto;
    position: fixed;
    right: 0;
    top: 0;
    width: 100%;
    z-index: 1000;

    &.slide-and-fade-enter-active,
    &.slide-and-fade-leave-active {
      transition: opacity .5s,  transform .5s;
    }

    &.slide-and-fade-enter,
    &.slide-and-fade-leave-to {
      opacity: 0;
      transform: translateX(100%);
    }

    &__header {
      padding: 47px 43px 0;

      &__title {
        font-size: 22px;
        font-weight: 900;
        margin: 0;
        text-transform: uppercase;
      }

      &__close {
        background: transparent;
        border: 0;
      }
    }

    &__body {
      font-size: 18px;
      padding: 38px 43px 47px;
    }
  }
</style>
